import React from 'react'

export function StructuredData({ children }) {
	return <script type="application/ld+json">{JSON.stringify(children, null, 2)}</script>
}